import DriveReservationRequestType from '../constants/DriveReservationRequestType';
import DriveAvailableAssets from '../models/DriveAvailableAssets';

export interface DriveAsset {
  id: number;
  groupId: number;
  classId: number;
  description: string;
  brand: {
    name: string;
    logoUrl: string;
  };
  registrationNumber: string;
  a_id: string;
}

export interface DriveClass {
  id: number;
  code: string;
  groupId: number;
  description: string;
  externalClassReference: string;
  a_id: string;
  availability: number;
  assets: DriveAsset[];
}

export interface DriveGroup {
  id: number;
  description: string;
  a_id: string;
  classes: DriveClass[];
  assets: DriveAsset[];
  availability: number;
}

export type DriveNestedData = DriveAsset[] | DriveClass[] | DriveGroup[];

export function fromReceivedDriveReservationToDriveReservationAssetsSelection(data: DriveAvailableAssets): DriveNestedData {
  if (!data || !data.visibilitySettings) {
    return [];
  }

  const classMap = new Map();
  if (data.visibilitySettings.classes || data.bookingSettings.classes) {
    data.classes.forEach(cls => {
      classMap.set(cls.id, { ...cls, assets: [], a_id: `${DriveReservationRequestType.CLASS}-${cls.id}` });
    });
  }

  const groupAssetsMap = new Map();
  data.assets.forEach(asset => {
    if (!(data.visibilitySettings.assets || data.bookingSettings.assets)) {
      return;
    }

    if (asset.classId && classMap.has(asset.classId)) {
      classMap.get(asset.classId).assets.push({ ...asset, a_id: `${DriveReservationRequestType.ASSET}-${asset.id}` });
    } else {
      if (!groupAssetsMap.has(asset.groupId)) {
        groupAssetsMap.set(asset.groupId, []);
      }
      groupAssetsMap.get(asset.groupId).push({ ...asset, a_id: `${DriveReservationRequestType.ASSET}-${asset.id}` });
    }
  });

  let nestedData: DriveNestedData = [];

  if (data.visibilitySettings.groups || data.bookingSettings.groups) {
    nestedData = data.groups.map(group => ({
      ...group,
      a_id: `${DriveReservationRequestType.GROUP}-${group.id}`,
      assets: (data.visibilitySettings.assets || data.bookingSettings.assets) ? groupAssetsMap.get(group.id) || [] : [],
      classes: (data.visibilitySettings.classes || data.bookingSettings.classes)
        ? data.classes.filter(cls => cls.groupId === group.id).map(cls => ({
          ...cls,
          a_id: `${DriveReservationRequestType.CLASS}-${cls.id}`,
          assets: classMap.get(cls.id)?.assets.map(a => ({ ...a, a_id: `${DriveReservationRequestType.ASSET}-${a.id}` })) || [],
        }))
        : [],
    }));
  } else if (data.visibilitySettings.classes || data.bookingSettings.classes) {
    nestedData = data.classes.map(cls => ({
      ...cls,
      a_id: `${DriveReservationRequestType.CLASS}-${cls.id}`,
      assets: (data.visibilitySettings.assets || data.bookingSettings.assets)
        ? data.assets.filter(asset => asset.classId === cls.id).map(a => ({ ...a, a_id: `${DriveReservationRequestType.ASSET}-${a.id}` }))
        : [],
    }));
  } else if (data.visibilitySettings.assets || data.bookingSettings.assets) {
    nestedData = data.assets.map(a => ({ ...a, a_id: `${DriveReservationRequestType.ASSET}-${a.id}` }));
  }

  return nestedData;
}